import { FullscreenModal } from "@/components/modals/FullscreenModal";
import type { ReactNode, RefObject } from "react";

interface CategoryModalProps {
  open: boolean;
  children: ReactNode;
  contentRef?: RefObject<HTMLDivElement>;
  onClose?: () => void;
  onSwipeClose?: () => void;
}

/** Full-screen category listing; children stay mounted through the exit slide. */
export function CategoryModal(props: CategoryModalProps) {
  return <FullscreenModal {...props} title="Categoria" keepChildrenWhileClosing />;
}
